// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"17dd6fa2","488":"e88a876c"}[chunkId] + ".chunk.js";
};